module.exports = __webpack_public_path__ + "img/Government_services.971cee51.svg";